document.addEventListener('DOMContentLoaded', () => {
  // Fix: Horizon inline transforms that break layout on mobile
  document.querySelectorAll('.image-banner [style*="transform"]').forEach((el) => {
    el.style.transform = 'none';
  });
});
